import React, { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { Controller, useForm, useWatch } from "react-hook-form";
import { DatePicker } from "rsuite";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { printData } from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";
import SearchSelectBox from "../../../components/comman/SearchSelectBox";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function CreateGRN() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [errorState, setErrorState] = useState("");
  const [files, setFiles] = useState([]);
  const [state, setState] = useState({
    purchaseList: [],
    siteId: "",
    siteName: "",
    purchaseId: "",
    purchaseLoading: false,
    isLoadingSite: false,
    supplyItems: [],
    EditData: null,
    grnDetails: {},
    loadingItems: false,
    purchaseDetail: [],
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    financialYear: "--",
  });

  // console.log("location=====>", location?.state?.type);

  const {
    register,
    setValue,
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", defaultValues: { grnHead: [] } });

  const grnHead = useWatch({ control, name: "grnHead" });

  const GetAllSitesList = (inputValue = null) => {
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site +
      `?type=site${inputValue ? `&search=${inputValue}` : ""}`;
    callApi(API, options).then((response) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site
            ?.filter((item) => item?.type === "O&M")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
          projectSites: response?.data?.site
            ?.filter((item) => item?.type === "project")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
        }));
      }
    });
  };

  const getAssignedSites = (inputValue = null) => {
    const option = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetGrnDetail = (id) => {
    const API = apiUrl?.get_GRN_detail + `grnId=${id}`;
    callApi(API, { method: "GET" }).then((res) => {
      if (res?.status === true) {
        setState((prev) => ({ ...prev, grnDetails: res?.data }));
      }
    });
  };

  useEffect(() => {
    if (userDetails?.type === 2) {
      GetAllSitesList();
    } else {
      getAssignedSites();
    }
    if (location?.state?.type === "Create") {
      const API =
        apiUrl?.get_purchase_detail + `purchaseId=${location?.state?.data?.id}`;
      callApi(API, { method: "GET" }).then((res) => {
        if (res?.status === true) {
          setState((prev) => ({ ...prev, purchaseDetail: res?.data }));
        }
      });
    } else if (location?.state?.type === "Update") {
      GetGrnDetail(location?.state?.data?.id);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.type === "Create" && state?.purchaseDetail) {
      setState((prev) => ({
        ...prev,
        purchaseId: state?.purchaseDetail.id,
        siteId: state?.purchaseDetail?.purchaserequest?.site?.id,
        siteName: state?.purchaseDetail?.purchaserequest?.site?.name,
        financialYear: state?.purchaseDetail?.financialYear || "--",
      }));
      const grnHead =
        state?.purchaseDetail?.purchaserequest?.purchaserequestexpenseheads?.map(
          (expense) => ({
            expenseHeadId: expense?.expenseHeadId,
            name: expense?.expensehead?.name,
            items: expense?.supplyrequestitems?.map((item) => ({
              itemId: item?.itemId,
              name: item?.item?.name,
              updatedQuantity: item?.updatedQuantity,
              receivedQuantity: item?.receivedQuantity || 0,
              remainingQuantity:
                parseFloat(item?.updatedQuantity) -
                parseFloat(item?.receivedQuantity || 0),
              quantity: "",
            })),
          })
        );

      reset({
        grnHead,
        siteId: state?.purchaseDetail?.purchaserequest?.site?.id,
      });
    }

    if (location?.state?.type === "Update" && state?.grnDetails) {
      setState((prev) => ({
        ...prev,
        purchaseId: state?.grnDetails?.purchase?.id,
        siteId: state?.grnDetails?.site?.id,
        siteName: state?.grnDetails?.site?.name,
        financialYear: state?.grnDetails?.purchase?.financialYear || "--",
      }));
      const grnHead =
        state?.grnDetails?.purchase?.purchaserequest?.purchaserequestexpenseheads?.map(
          (expense) => {
            const expenseHead = state?.grnDetails?.grnheads?.find(
              (exp) => exp?.expensehead?.id === expense?.expensehead?.id
            );
            return {
              expenseHeadId: expense?.expenseHeadId,
              name: expense?.expensehead?.name,
              items: expense?.supplyrequestitems?.map((item) => {
                const foundItemsQuantity = expenseHead?.grnitems?.find(
                  (qty) => qty?.item?.id === item?.item?.id
                );
                printData(expenseHead, foundItemsQuantity);
                return {
                  itemId: item?.itemId,
                  name: item?.item?.name,
                  updatedQuantity: item?.updatedQuantity,
                  receivedQuantity: item?.receivedQuantity || 0,
                  remainingQuantity:
                    parseFloat(item?.updatedQuantity) -
                    parseFloat(item?.receivedQuantity || 0),
                  quantity: foundItemsQuantity?.quantity || "",
                };
              }),
            };
          }
        );

      reset({
        content: state?.grnDetails?.description || "",
        siteId: state?.grnDetails?.site?.id,
        grnHead,
      });

      if (state?.grnDetails?.documents?.length > 0) {
        setExistingDocuments(state?.grnDetails?.documents);
      }
    }
  }, [state?.grnDetails, state?.purchaseDetail]);

  const fetchPurchaseOrderList = (inputValue) => {
    return new Promise((resolve) => {
      const site = state?.siteId || "";
      const API = `${apiUrl.get_purchase
        }from=grn&type=supplyRequest&siteId=${site}${inputValue ? `&search=${inputValue}` : ""
        }`;

      setState((prev) => ({ ...prev, purchaseLoading: true }));

      callApi(API, { method: "GET" }).then((res) => {
        setState((prev) => ({ ...prev, purchaseLoading: false }));
        if (res?.status) {
          const formatted = res?.data?.purchase?.map((p) => ({
            value: p.id,
            label: p.purchaseNumber,
          }));

          const selectedPurchase = res?.data?.purchase?.find(
            (p) => p?.id === location?.state?.data?.purchaseId
          );

          setState((prev) => ({
            ...prev,
            purchaseList: res?.data?.purchase,
          }));

          resolve(formatted);
        } else resolve([]);
      });
    });
  };

  const onSubmit = (data) => {
    const { grnHead, content } = data;

    if (!state?.siteId) {
      toast.error("Please select site.");
      return;
    }
    const grnhead = grnHead
      ?.map((head) => {
        const grnItem = head.items
          .filter((item) => item.quantity && parseFloat(item.quantity) > 0)
          .map((item) => {
            const processedItem = {
              itemId: item.itemId,
              quantity: parseFloat(item.quantity),
            };
            // items.push(processedItem);
            return processedItem;
          });

        return {
          expenseHeadId: head.expenseHeadId,
          grnItem,
        };
      })
      .filter((head) => head.grnItem.length > 0);

    const totalValidItems = grnhead.reduce(
      (acc, head) => acc + head.grnItem.length,
      0
    );
    if (totalValidItems === 0) {
      toast.error("Please enter quantity for at least one item.");
      return;
    }

    const postData = {
      date: data.date,
      description: content,
      grnHead: JSON.stringify(grnhead),
      siteId: state.siteId,
      purchaseId: state.purchaseId,
    };

    // console.log(postData);

    const formData = new FormData();
    for (const key in postData) {
      if (postData[key]) formData.append(key, postData[key]);
    }

    files.forEach((f) => formData.append(f.file.name, f.file));

    const isUpdate = location?.state?.type === "Update";
    const api = isUpdate
      ? `${apiUrl.update_GRN}?grnId=${location?.state?.data?.id}`
      : apiUrl.create_GRN;
    const method = "POST";

    setIsLoading(true);
    callApi(api, { method, form_data: formData })
      .then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(
            response?.message ||
            `${isUpdate ? "Updated" : "Created"} GRN successfully.`
          );
          navigate(RoutesLink.grn);
        } else {
          toast.error(response?.message || "Something went wrong.");
        }
      })
      .catch((error) => {
        toast.error("An unexpected error occurred.");
        console.error(error);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const handleSelectPO = (data) => {
    let API = apiUrl?.get_purchase_detail + `purchaseId=${data?.value}`;
    setState((prev) => ({
      ...prev,
      loadingItems: true,
    }));
    callApi(API).then((response) => {
      setState((prev) => ({
        ...prev,
        loadingItems: false,
      }));
      if (response?.status) {
        setState((prev) => ({
          ...prev,
          purchaseId: data?.value,
          financialYear: response?.data?.financialYear || "--",
        }));
        const grnHead =
          response?.data?.purchaserequest?.purchaserequestexpenseheads?.map(
            (expense) => ({
              expenseHeadId: expense?.expenseHeadId,
              name: expense?.expensehead?.name,
              items: expense?.supplyrequestitems?.map((item) => ({
                itemId: item?.itemId,
                name: item?.item?.name,
                updatedQuantity: item?.updatedQuantity,
                receivedQuantity: item?.receivedQuantity || 0,
                remainingQuantity:
                  parseFloat(item?.updatedQuantity) -
                  parseFloat(item?.receivedQuantity || 0),
                quantity: "",
              })),
            })
          ) || [];

        reset({
          grnHead,
          // siteId: state?.purchaseDetail?.purchaserequest?.siteId,
        });
      }
    });
  };

  // printData("SupplyItems", state?.supplyItems);

  return (
    <>
      {state.loadingItems && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.type ? location?.state?.type : "Create"} GRN
            </h1>
          </div>
        </div>
        <form id="againstPO" onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                              financialYear: "--",
                            }));
                          }}
                          onBlur={field.onBlur}
                          options={
                            userDetails?.type === 2
                              ? state?.OandMSites
                              : state.assignedSites
                          }
                          onSearch={
                            userDetails?.type === 2
                              ? GetAllSitesList
                              : getAssignedSites
                          }
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={location?.state?.data}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="customerSearch" className="form-label">
                      Purchase Order
                    </label>

                    {/* Search Input */}
                    <SearchSelectBox
                      value={state?.purchaseId}
                      fetchOptions={fetchPurchaseOrderList}
                      loading={state.purchaseLoading}
                      isAsync={true}
                      defaultFetch={state.siteId}
                      title={
                        (
                          state?.purchaseList?.length === 0 ||
                            location?.state?.data
                            ? true
                            : false
                        )
                          ? "No record found"
                          : "Search Purchase Order"
                      }
                      error={errorState}
                      disable={location?.state?.data ? true : false}
                      onChange={handleSelectPO}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Financial Year
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={state.financialYear || "--"}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          shouldDisableDate={(date) => date > new Date()}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                {/* <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={toggleModal}
                    disabled={location?.state?.type === "Create" ? !state?.grnDetails?.purchaserequest
                      ?.purchaserequestexpenseheads : !state?.grnDetails?.grnheads}
                  >
                    Add Material
                  </button>
                </div> */}

                {grnHead?.length > 0 && (
                  <div className="mt-4 w-100">
                    {grnHead.map((expense, index) => (
                      <div key={index} className="card border mb-4">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className="text-primary m-0">{expense.name}</h3>
                          </div>
                          {expense?.items?.length > 0 && (
                            <div className="table-responsive">
                              <table className="table table-bordered table-striped">
                                <thead className="table-light">
                                  <tr>
                                    <th>Item Name</th>
                                    <th>Approved Quantity</th>
                                    <th>Received Quantity</th>
                                    <th>Remaining Quantity</th>
                                    <th>Quantity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {expense.items.map((item, i) => (
                                    <tr key={i}>
                                      <td>{item.name}</td>
                                      <td>{item.updatedQuantity}</td>
                                      <td>{item.receivedQuantity}</td>
                                      <td>{item.remainingQuantity}</td>
                                      <td style={{ minWidth: "100px" }}>
                                        <input
                                          type="number"
                                          onWheel={(e) => e.target.blur()}
                                          className={`form-control ${errors?.grnHead?.[index]?.items?.[i]
                                            ?.quantity
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                          placeholder="Quantity"
                                          {...register(
                                            `grnHead.${index}.items.${i}.quantity`,
                                            {
                                              validate: (value) => {
                                                let qty = value
                                                  .replace(/[^0-9.]/g, "")
                                                  .replace(/(\..*)\./g, "$1");
                                                if (
                                                  !/^\d*\.?\d*$/.test(value)
                                                ) {
                                                  value = "";
                                                }
                                                setValue(
                                                  `grnHead.${index}.items.${i}.quantity`,
                                                  qty
                                                );
                                                // if (qty <= 0) return "Must be > 0";
                                                const numericValue =
                                                  Number(qty);
                                                const remainingQty =
                                                  item.remainingQuantity;
                                                if (
                                                  numericValue > remainingQty
                                                ) {
                                                  return `Quantity cannot exceed ${remainingQty}`;
                                                }
                                                return true;
                                              },
                                            }
                                          )}
                                        />
                                        {errors?.grnHead?.[index]?.items?.[i]
                                          ?.quantity && (
                                            <div className="invalid-feedback">
                                              {
                                                errors.grnHead[index].items[i]
                                                  .quantity.message
                                              }
                                            </div>
                                          )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="row">
                  <div className="col-12  " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Uploads
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => handleDeleteDocument(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div> */}
                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required",
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px",
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? (
                    <Spinner />
                  ) : location?.state?.type ? (
                    location?.state?.type
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
